// extracted by mini-css-extract-plugin
module.exports = {"pointsRange":"PointsRange_pointsRange__xY6wQ"};